import { render, staticRenderFns } from "./Verification.vue?vue&type=template&id=c71708a2&scoped=true"
import script from "./Verification.vue?vue&type=script&lang=js"
export * from "./Verification.vue?vue&type=script&lang=js"
import style0 from "./Verification.vue?vue&type=style&index=0&id=c71708a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71708a2",
  null
  
)

export default component.exports